import type { getAppPageDataResponse } from '../app-page-api';
import { getAppPageDataById, getAppPageDataBySlug } from '../app-page-api';
import type { Services } from '@wix/app-market-services';
import type { SupportedAppStatuses } from '@wix/app-market-services-types';
import type { ISiteContext } from '@wix/app-market-core';
import type Experiments from '@wix/wix-experiments';
import type { AppFetchOptions } from '../types';

export const getAppModalData = async ({
  services,
  languageCode,
  siteContext,
  experiments,
  id,
  slug,
  status = 'PUBLISHED',
  options,
}: {
  services: Services;
  languageCode: string;
  siteContext: ISiteContext;
  experiments: Experiments;
  id?: string;
  slug?: string;
  status?: SupportedAppStatuses;
  options?: AppFetchOptions;
}): Promise<getAppPageDataResponse> => {
  return id
    ? getAppPageDataById({
        services,
        id,
        languageCode,
        siteContext,
        status,
        experiments,
        options,
      })
    : slug
    ? getAppPageDataBySlug({
        services,
        slug,
        languageCode,
        status,
        siteContext,
        experiments,
        options,
      })
    : Promise.reject(new Error('(getAppModalData): No id or slug provided'));
};
